import { render } from "./QuickDrawer.vue?vue&type=template&id=abde7126&scoped=true"
import script from "./QuickDrawer.vue?vue&type=script&lang=js"
export * from "./QuickDrawer.vue?vue&type=script&lang=js"

import "./QuickDrawer.vue?vue&type=style&index=0&id=abde7126&lang=scss&scoped=true"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abde7126"]])

export default __exports__